"use client";

import { Geist, Geist_Mono } from "next/font/google";
import "./globals.css";

import CustomCursor from "./components/ui/CustomCursor";
import Footer from "./components/ui/Footer";
import Navbar from "./components/ui/Navbar";
import WhatsAppButton from "./components/ui/WhatsAppButton";
import Script from "next/script";
import { CartProvider } from "./context/CartContext";

import { usePathname } from "next/navigation";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const isAdminPage = pathname.startsWith("/admin");

  return (
    <html
      lang="en"
      className={`${geistSans.variable} ${geistMono.variable}`}
    >
      <body className="min-h-full flex flex-col">
        <CartProvider>
          {!isAdminPage && <Navbar />}

          <main className="flex-grow">
            {children}
          </main>

          {!isAdminPage && <Footer />}

          {!isAdminPage && <CustomCursor />}

          {!isAdminPage && <WhatsAppButton />}
        </CartProvider>

        <Script
          src="https://www.instagram.com/embed.js"
          strategy="lazyOnload"
        />

      </body>
    </html>
  );
}